<div class="tutorial-modal-backdrop" *ngIf="isTutorialPanelOpen" (click)="closeTutorialPanelOnBackdrop($event)">
  <section class="tutorial-modal" role="dialog" aria-modal="true" [attr.aria-label]="modalAriaLabel">
    <div class="tutorial-modal-header">
      <div>
        <span class="tutorial-modal-eyebrow">{{ activeIntroLabel }}</span>
        <h2>{{ activeTitle }}</h2>
      </div>
      <div class="tutorial-modal-actions">
        <button type="button" class="tutorial-close-btn" (click)="closeTutorialPanel()" aria-label="Close tutorial popup">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="tutorial-player-shell" [class.is-loading]="isTutorialLoading">
      <div *ngIf="isPreparingNextStep" class="tutorial-state tutorial-state-next-step">
        <div class="tutorial-next-step-header">
          <mat-icon aria-hidden="true">play_circle_outline</mat-icon>
          <span class="tutorial-next-step-label">Up next</span>
        </div>
        <ng-container *ngIf="nextStepRecommendations.length > 1; else singleNextVideo">
          <p>Choose your next walkthrough</p>
          <div class="tutorial-recommendations">
            <button
              *ngFor="let step of nextStepRecommendations"
              type="button"
              class="tutorial-recommendation"
              [attr.aria-label]="'Play ' + step.title"
              (click)="playNextTutorialVideo(step.screenId)">
              <mat-icon aria-hidden="true">play_circle_outline</mat-icon>
              <span class="tutorial-recommendation-title">{{ step.title }}</span>
              <span class="tutorial-recommendation-action">Play video</span>
            </button>
          </div>
        </ng-container>
        <ng-template #singleNextVideo>
          <p>{{ nextStepTitle }}</p>
          <button type="button" class="tutorial-next-btn" (click)="playNextTutorialVideo()">Play next video</button>
        </ng-template>
      </div>

      <div *ngIf="!isTutorialLoading && tutorialVideoError" class="tutorial-state tutorial-state-error">
        <mat-icon>error_outline</mat-icon>
        <p>{{ tutorialVideoError }}</p>
        <button type="button" class="tutorial-retry-btn" (click)="openTutorialPanel()">Try again</button>
      </div>

      <video
        #tutorialVideoPlayer
        *ngIf="!isPreparingNextStep && !isTutorialLoading && !tutorialVideoError && tutorialVideoUrl"
        class="tutorial-video"
        controls
        controlsList="nodownload"
        preload="metadata"
        (play)="onTutorialVideoPlay()"
        (ended)="onTutorialVideoEnded()"
        (error)="onTutorialVideoPlaybackError()"
        autoplay>
        <source [src]="tutorialVideoUrl" [type]="tutorialContentType">
        Your browser does not support the tutorial video.
      </video>
    </div>
  </section>
</div>

<aside
  class="tutorial-teaser"
  [ngClass]="teaserPositionClass"
  *ngIf="showTutorialBanner && !isTutorialPanelOpen"
  [attr.aria-label]="modalAriaLabel">
  <button type="button" class="tutorial-teaser-dismiss" (click)="dismissTutorialBanner()" aria-label="Dismiss tutorial teaser">
    <mat-icon>close</mat-icon>
  </button>

  <div class="tutorial-teaser-badge">
    <mat-icon>smart_display</mat-icon>
    Tutorial video
  </div>

  <h3>{{ teaserTitle }}</h3>
  <p>{{ teaserDescription }}</p>

  <button type="button" class="tutorial-teaser-action" (click)="openTutorialPanel()">
    <mat-icon>play_circle</mat-icon>
    {{ teaserButtonLabel }}
  </button>
</aside>

<div
  class="tutorial-reopen-wrap"
  [class.tutorial-reopen-wrap--dismissable]="allowLauncherDismiss"
  [ngClass]="launcherPositionClass"
  *ngIf="!showTutorialBanner && !isTutorialPanelOpen && showTutorialLauncher">
  <button
    type="button"
    class="tutorial-reopen-btn"
    [class.tutorial-reopen-btn--dismissable]="allowLauncherDismiss"
    (click)="openTutorialPanel()"
    [attr.aria-label]="reopenAriaLabel"
    [attr.title]="launcherLabel">
    <mat-icon>play_circle</mat-icon>
    <span>{{ launcherLabel }}</span>
  </button>

  <button
    *ngIf="allowLauncherDismiss"
    type="button"
    class="tutorial-launcher-dismiss"
    (click)="dismissTutorialLauncher($event)"
    aria-label="Dismiss tutorial launcher">
    <mat-icon>close</mat-icon>
  </button>
</div>